import { render, staticRenderFns } from "./trusteeship.vue?vue&type=template&id=56a84eac&scoped=true&"
import script from "./trusteeship.vue?vue&type=script&lang=js&"
export * from "./trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./trusteeship.vue?vue&type=style&index=0&id=56a84eac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a84eac",
  null
  
)

export default component.exports